import { render, staticRenderFns } from "./StepArtigo.vue?vue&type=template&id=efb35fd2&scoped=true"
import script from "./StepArtigo.vue?vue&type=script&lang=js"
export * from "./StepArtigo.vue?vue&type=script&lang=js"
import style0 from "./StepArtigo.vue?vue&type=style&index=0&id=efb35fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb35fd2",
  null
  
)

export default component.exports